import { LANGUAGE_PREFERENCE_LOCALSTORAGE_KEY } from './localStorageKeyPrefix';

const SUPPORT_EMAIL = 'support@reach4help.org';

export default {
  LANGUAGE_PREFERENCE_LOCALSTORAGE_KEY,
  SUPPORT_EMAIL,
};
